import { useTextDomainContext } from "@/app/providers";
import React, { ReactElement, useContext } from "react";
import { Level1MenuItem } from "@/features";
import Logout from "@mui/icons-material/Logout";
import { permissionsAllowToAll } from "@/utils";

const parentPath = "logout";

export const LogoutMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  return (
    <Level1MenuItem
      link={`/${parentPath}`}
      label={gettext("Sign Out")}
      icon={<Logout className="mx-3" />}
      feature="common"
      codes={permissionsAllowToAll}
    />
  );
};
